<button class="fab_support_chat" (click)="goToChat()" role="link" aria-label="Whatsapp">
    <i class="fab fa-whatsapp" aria-hidden="true"></i>
</button>